.#{$namespace}-dialog {
	position: relative;
	margin: 0 auto 50px;
	background: $white-color;
	border-radius: 4px;
	box-shadow: 0 12px 32px alpha-color($black-color, 12%);
	box-sizing: border-box;
	width: 50%;

	// overlay 已 flex 居中，去掉默认 bottom margin，否则竖直方向会偏上
	&.is-align-center {
		margin: 0;
	}

	&.is-fullscreen {
		width: 100%;
		height: 100%;
		margin: 0;
		border-radius: 0;
		display: flex;
		flex-direction: column;
	}

	&__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 16px 16px 10px;
		gap: 8px;
	}

	&__title {
		font-size: calc($font-size + 2px);
		font-weight: 600;
		color: $text-primary-color;
		line-height: 1.4;
	}

	&__headerbtn {
		padding: 0;
		border: none;
		background: transparent;
		cursor: pointer;
		font-size: 16px;
		color: $text-placeholder-color;
		line-height: 1;

		&:hover {
			color: color-token(primary);
		}
	}

	&__body {
		padding: 10px 16px 16px;
		color: $text-secondary-color;
		font-size: $font-size;
		word-break: break-word;

		.is-fullscreen & {
			flex: 1;
			overflow: auto;
		}
	}

	&__footer {
		padding: 0 16px 16px;
		text-align: right;

		.#{$namespace}-button + .#{$namespace}-button {
			margin-left: 12px;
		}
	}
}

.#{$namespace}-dialog-fade-enter-active {
	animation: #{$namespace}-dialog-fade-in 0.3s;
}

.#{$namespace}-dialog-fade-leave-active {
	animation: #{$namespace}-dialog-fade-out 0.3s;
}

@keyframes #{$namespace}-dialog-fade-in {
	0% {
		opacity: 0;
		transform: translateY(-20px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

@keyframes #{$namespace}-dialog-fade-out {
	0% {
		opacity: 1;
		transform: translateY(0);
	}
	100% {
		opacity: 0;
		transform: translateY(-20px);
	}
}
